import { HRP_RECONCILIATION_ACTION_MENU_HINT } from "../../utils/billingRateUtils";

const plural = (count, singular, pluralForm = `${singular}s`) => (
    count === 1 ? singular : pluralForm
);

const BillingRateBuilderHrpReconciliationSummary = ({
    reconciliationRows,
    needsReview,
    onOpen,
    clientName,
    reconciliationSettled = false,
}) => {
    const pending = reconciliationSettled
        ? []
        : (reconciliationRows ?? []).filter((r) => !r.confirmed && !r.skipped);
    const reviewCount = pending.filter(needsReview).length;
    const readyCount = pending.filter((r) => !needsReview(r)).length;
    const savedCount = (reconciliationRows ?? []).filter((r) => r.confirmed || r.skipped).length;
    const allResolved = pending.length === 0;
    const needsAttention = reviewCount > 0;

    const clientLabel = clientName?.trim() || "this client";

    let titleLine1;
    let titleLine2;
    let bodyLines;
    let ctaLabel;

    if (allResolved) {
        titleLine1 = "HRP component links saved";
        titleLine2 = null;
        bodyLines = [
            "Your choices are saved. You can reopen the review panel or continue to rates.",
        ];
        ctaLabel = "View saved links →";
    } else if (needsAttention) {
        titleLine1 = "Review HRP component links";
        const statParts = [`${reviewCount} need attention`];
        if (readyCount > 0) statParts.push(`${readyCount} ready`);
        if (savedCount > 0) statParts.push(`${savedCount} saved`);
        titleLine2 = statParts.join(" · ");
        bodyLines = [
            `We linked fees from your upload to existing billing components for ${clientLabel}.`,
            `${reviewCount} ${plural(reviewCount, "link")} need a closer look — choose ${HRP_RECONCILIATION_ACTION_MENU_HINT} for each row, then save before continuing to rates.`,
        ];
        ctaLabel = "Review links →";
    } else {
        titleLine1 = "Confirm HRP component links";
        titleLine2 = savedCount > 0
            ? `${readyCount} ready · ${savedCount} saved`
            : `${readyCount} ready`;
        bodyLines = [
            `We linked ${readyCount} ${plural(readyCount, "fee")} from your upload to existing billing components in HRP for ${clientLabel}.`,
            "Defaults are pre-selected — open the review panel to confirm or change each row, then save before continuing to rates.",
        ];
        ctaLabel = "Review and save →";
    }

    const alertModifier = allResolved
        ? "success"
        : needsAttention
            ? "warning"
            : "info";

    return (
        <div
            className={[
                "billing-rate-builder__alert",
                `billing-rate-builder__alert--${alertModifier}`,
                "billing-rate-builder__hrp-summary",
            ].join(" ")}
        >
            <div className="billing-rate-builder__hrp-summary-main">
                <p className="title billing-rate-builder__alert-title">
                    {titleLine1}
                </p>
                {titleLine2 && (
                    <p className="billing-rate-builder__hrp-summary-stats">{titleLine2}</p>
                )}
                {bodyLines.map((line) => (
                    <p key={line} className="billing-rate-builder__alert-body-plain">
                        {line}
                    </p>
                ))}
            </div>
            <div className="billing-rate-builder__alert-actions billing-rate-builder__hrp-summary-actions">
                <button type="button" className="btn edit-btn" onClick={onOpen}>
                    {ctaLabel}
                </button>
            </div>
        </div>
    );
};

export default BillingRateBuilderHrpReconciliationSummary;
